module.exports = __webpack_public_path__ + "static/media/574b35d4-2577-46e7-9429-60189209ac92.cc263944.JPG";